/*
 * Created Date: 14-03-2024, 12:00:45 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Mar 14 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'
import { hasExamDb } from '@Core/axios/middleware'

class QuestionService extends BaseService {
	BASE_ENDPOINT = '/quizexam/studio/api/v1/admin/questions'

	paramsGet = {
		sort: 'sort_order',
		dir: 'asc'
		// telescope: 1
	}

	constructor() {
		super()
		this.applyMiddleware('exam-db', hasExamDb)
		this.setRequest()
	}
}

const adminQuestionService = new QuestionService()
export default adminQuestionService
